import {FETCH_RATE_CARD, FETCH_RATE_CARD_SUCCESS, FETCH_RATE_CARD_ERROR, UPDATE_RATE_CARD, UPDATE_RATE_CARD_SUCCESS, UPDATE_RATE_CARD_ERROR, RESET_UPDATE_RATE_CARD} from 'constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  updating: false,
  data: [],
  payload: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_RATE_CARD: {
      return {...state, error: '', loading: true};
    }
    case UPDATE_RATE_CARD: {
      return {...state, error: '', updating: true};
    }
    case FETCH_RATE_CARD_SUCCESS: {
      return {...state, error: '', data: action.payload, loading: false};
    }
    case UPDATE_RATE_CARD_SUCCESS: {
      return {...state, error: '', payload: { code: 200, message: 'Cập nhật dữ liệu thành công!' }, updating: false};
    }
    case FETCH_RATE_CARD_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case UPDATE_RATE_CARD_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case RESET_UPDATE_RATE_CARD: {
      return {...state, payload: {}};
    }
    default:
      return state;
  }
}
